import { render, staticRenderFns } from "./ReceivedAmountItem.vue?vue&type=template&id=77c86ad5&scoped=true&"
import script from "./ReceivedAmountItem.vue?vue&type=script&lang=js&"
export * from "./ReceivedAmountItem.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedAmountItem.vue?vue&type=style&index=0&id=77c86ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c86ad5",
  null
  
)

export default component.exports